<script>
import { mapGetters, mapActions } from 'vuex';
import analytics from 'Analytics';

export default {
  name: 'TheAnalytics',
  computed: {
    ...mapGetters('analytics', [
      'analyticsMessagesData',
    ]),
    ...mapGetters('profile', [
      'isFinancialSituationSpecified',
    ]),
    linkFirstBankAccountMessage() {
      return this.analyticsMessagesData.find(m => (
        m.message.event === 'user_link_first_bank_account'
      ));
    },
    passedAccreditationMessage() {
      return this.analyticsMessagesData.find(m => (
        m.message.event === 'user_passed_accreditation'
      ));
    },
    verifiedMessage() {
      return this.analyticsMessagesData.find(m => (
        m.message.event === 'user_verified'
      ));
    },
    wasPassedAccreditation() {
      return this.isFinancialSituationSpecified && Boolean(
        this.passedAccreditationMessage && !this.passedAccreditationMessage.read_flag,
      );
    },
    wasLinkFirstBankAccount() {
      return this.linkFirstBankAccountMessage && !this.linkFirstBankAccountMessage.read_flag;
    },
    isPersonVerified() {
      return this.verifiedMessage && !this.verifiedMessage.read_flag;
    },
    isAccreditedAndLink() {
      return this.wasPassedAccreditation && this.wasLinkFirstBankAccount;
    },
  },
  watch: {
    wasPassedAccreditation: {
      handler(wasPassedAccreditation) {
        if (!wasPassedAccreditation) return;
        analytics.triggerAccreditedOnce();
        this.setMessageAsRead(this.passedAccreditationMessage.id);
      },
      immediate: true,
    },
    isAccreditedAndLink: {
      handler(isAccreditedAndLink) {
        if (!isAccreditedAndLink) return;
        analytics.triggerAccreditedAndLinkedBankAccount();
        this.setMessageAsRead(this.linkFirstBankAccountMessage.id);
      },
      immediate: true,
    },
    isPersonVerified: {
      handler(isVerified) {
        if (!isVerified) return;
        analytics.triggerPersonVerified();
        this.setMessageAsRead(this.verifiedMessage.id);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('analytics', [
      'setMessageAsRead',
    ]),
  },
  render() {
    return null;
  },
};
</script>
